import { render } from "./SocialBadge.vue?vue&type=template&id=1931c792&scoped=true&ts=true"
import script from "./SocialBadge.vue?vue&type=script&lang=ts"
export * from "./SocialBadge.vue?vue&type=script&lang=ts"

import "./SocialBadge.vue?vue&type=style&index=0&id=1931c792&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1931c792"]])

export default __exports__